import { render, staticRenderFns } from "./ModalPatientEcgTable.vue?vue&type=template&id=21342d6e&scoped=true&lang=pug"
import script from "./ModalPatientEcgTable.vue?vue&type=script&lang=js"
export * from "./ModalPatientEcgTable.vue?vue&type=script&lang=js"
import style0 from "./ModalPatientEcgTable.vue?vue&type=style&index=0&id=21342d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21342d6e",
  null
  
)

export default component.exports